import { getAddressString } from "../../../helpers/tableHelper";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { t } from "i18next";
import { dateFormatForSubmit } from "../../../constants";
export const getBgColor = (option) => (row, index) => {
  const { messageClassTypeId, triggerCause, messageCodeTypeColor } = row || {};
  if (messageCodeTypeColor != "") return messageCodeTypeColor;
  //if (triggerCause === "ТО") return "var(--bgGrey)";

  const colorItem = messageClassTypeId && option.find((item) => item.value === messageClassTypeId);

  return colorItem ? colorItem?.color : index % 2 ? "var(--bgTableRow)" : "var(--white)";
};
export const getBorderColor = (option) => (row, index) => {
  const { messageCodeTypeBorderColor } = row || {};
  if (messageCodeTypeBorderColor != "") return messageCodeTypeBorderColor;
};
export const getfacilityFilter = (facility) => {
  if (facility === "все" || !facility) return "";
  return facility;
};
export const showOnlyFireMessagesFilter = (value) => {
  if (value === 1) return true;
  if (value === 2) return false;
  return "";
};

export const getMessagefilter = (value) => {
  if (!value || value === -1) return -1;
  if (value === "fire_messages_amount") return 1;
  if (value === "false_fire_messages_amount") return 2;
};
export const reactionDateFilter = (date, name) => {
  if (!date) return "";
  const reactionDate = {};

  if (date[1] != null) reactionDate["ReactionDateRange.MaxValue"] = dayjs(date[1]).format(dateFormatForSubmit);
  if (date[0] != null) reactionDate["ReactionDateRange.MinValue"] = dayjs(date[0]).format(dateFormatForSubmit);

  return reactionDate;
};
export const getGlobalMessagefilter = (value) => {
  if (!value) return "";
  if (value === "fire_messages_amount") return "fire_messages_amount";
  if (value === "false_fire_messages_amount") return "false_fire_messages_amount";
  return false;
};

export const getFiltersObject = (params) => {
  const adressFilter = getAddressString(params?.searchAddress, "AddressFilter");
  const facilityId = getfacilityFilter(params?.facilityId);
  const messageFilter = showOnlyFireMessagesFilter(params?.showOnlyFireMessagesPerActiveSession);
  const reactionDate = reactionDateFilter(params?.reactionDateTime, "ReactionDateRange");

  return {
    ...params,
    searchAddress: adressFilter,
    ...reactionDate,
    facilityId: facilityId,
    showOnlyFireMessagesPerActiveSession: messageFilter,
  };
};

export const eventsOptions = [
  {
    value: "все",
    name: t(`options_name:all_fire_messages`),
  },
  {
    value: 1,
    name: t(`options_name:fire_messages_amount`),
  },
  {
    value: 2,
    name: t(`options_name:false_fire_messages_amount`),
  },
];
